import { render, staticRenderFns } from "./AudioControl.vue?vue&type=template&id=5459fc8b&scoped=true&"
import script from "./AudioControl.vue?vue&type=script&lang=js&"
export * from "./AudioControl.vue?vue&type=script&lang=js&"
import style0 from "./AudioControl.vue?vue&type=style&index=0&id=5459fc8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459fc8b",
  null
  
)

export default component.exports